<template>
  <!--width: calc(100% - 80px) !important;-->
  <div
    id="vueplayer"
    :class="isAdminComponent ? 'stage-view' : 'stage-view user-view'"
    :style="'background: #280304 !important; overflow-x:hidden; position: relative;'"
  >
    <!--:style="'background-image:url(' + eventBGImage + ');' + getHeight()"-->
    <!--:style="getHeight()"-->
    <div
      v-show="pageLoaded"
      :class="
        'd-flex justify-content-start position-absolute top-button-wrap' +
        pageLoaded
          ? ''
          : ' loading'
      "
      style=""
    >
      <div class="container-fluid border-bottom p-0 ss-reg-top">
        <div
          class="d-md-flex justify-content-end page-option-sticky"
          v-if="isAdminComponent"
        >
          <router-link
            to="/admin-sessions"
            class="pt-3 left-effect2"
            data-toggle="modal"
            data-target="#RegistrationtypeModal"
          >
            <!-- <v-icon color="#1c1d26" size="25px">mdi-monitor-eye</v-icon> -->

            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18px"
              height="18px"
              viewBox="0 0 22.97 22.969"
              fill="#5a646e"
              class="mr-1"
              id="v-step-1"
            >
              <defs></defs>
              <path
                id="view-sessions.svg"
                class="cls-1"
                d="M1713.47,669.756a6.962,6.962,0,0,1-7.92,0,3.358,3.358,0,0,1,0-6.518,6.962,6.962,0,0,1,7.92,0A3.361,3.361,0,0,1,1713.47,669.756Zm-1.87-5.38a2.91,2.91,0,0,0-4.18,0,3.02,3.02,0,0,0,0,4.242,2.91,2.91,0,0,0,4.18,0A3.02,3.02,0,0,0,1711.6,664.376Zm-2.09,3.919a1.7,1.7,0,0,1-1.25-.534,1.8,1.8,0,0,1,0-2.528,1.7,1.7,0,0,1,1.25-.534,1.676,1.676,0,0,1,1.24.534,1.772,1.772,0,0,1,0,2.528A1.676,1.676,0,0,1,1709.51,668.3Zm1.47-12.29h-15.96v9.977h6.12A3.994,3.994,0,0,0,1701,667a2.523,2.523,0,0,0,.21.977h-7.19a1,1,0,0,1-1-1V651.016a1,1,0,0,1,1-1h2.99v-2h2v2h7.98v-2h2v2h2.99a1,1,0,0,1,1,1v9.537a7.961,7.961,0,0,0-2-.494v-4.054Zm0-3.991h-15.96v2h15.96v-2ZM1698,658h9.99v2l-9.99,0v-2Zm0.01,3.991h5.98v0.035a8.919,8.919,0,0,0-1.93,1.96h-4.05v-2Z"
                transform="translate(-1693.03 -648.031)"
              />
            </svg>
            View Sessions
          </router-link>
          <!-- <a
            href="javascript:void(0);"
            class="pt-3 left-effect2"
            data-toggle="modal"
            data-target="#CheckoutformypeModal"
            @click="AdSettingsPop()"
          >
            <v-icon class="mr-1" color="#5a646e" size="18px" id="v-step-3"
              >mdi-cog-outline</v-icon
            >
            Advanced Settings
          </a>
          <v-btn
            class="my-2 mr-4 save-standard"
            outlined
            color="#2376e5"
            width="180px"
            @click="openAttendeePopup()"
            ><v-icon class="mr-1" color="#2376e5" size="20px">mdi-plus</v-icon>
            Add New Session</v-btn
          > -->
        </div>
      </div>
      <router-link to="/sessions">
        <v-btn
          id="btnAllSessions"
          color="white"
          class="stage-button px-2"
          style="color: #000; display: none"
        >
          All Sessions <v-icon class="ml-1"> menu </v-icon>
        </v-btn>
      </router-link>
      <!--v-show="!isMaximized"-->
      <v-btn
        v-show="false"
        id="btnEngage"
        color="white"
        class="stage-button px-2 ml-2"
        style="color: #000"
      >
        Chat & QnA <v-icon class="ml-1"> arrow_forward </v-icon
        ><span id="unreadCount"></span>
      </v-btn>
      <v-btn
        v-show="!isMaximized"
        id="btnMaximize"
        outlined="false"
        depressed
        min-width="0"
        color="white"
        class="stage-button px-2"
        style="color: #000; border: 0"
      >
        <v-icon> {{ isMaximized ? "fullscreen_exit" : "fullscreen" }} </v-icon>
      </v-btn>
    </div>
    <section
      id="sectionId"
      class="d-flex flex-column body-content p-0 full-height"
      v-html="pageHtml"
      @click="stageClicked"
      style="height: 100%; background: #280304"
    ></section>
    <LiveStage
      v-show="pageLoaded"
      id="live_stage"
      ref="liveStage"
      :key="stagePlayerKey"
      :exStageUrl="'/stageview'"
      @onResizeStage="onResizeStage"
      @onCallStarted="onCallStarted"
      @unreadChatCountChanged="unreadChatCountChanged"
      @unreadQnACountChanged="unreadQnACountChanged"
      style="min-width: 100%"
    />
    <div class="custom-v-tour">
      <v-tour
        name="adminStageViewTour"
        :steps="steps"
        :callbacks="tourCallbacks"
      ></v-tour>
    </div>

    <!--<v-carousel
      v-if="false"
      id="sponsorSlider1"
      vertical="true"
      hide-delimiters="true"
      next-icon="false"
      prev-icon="false"
      show-arrows="false"
      continuous="true"
      cycle="false"
      touchless="true"
      max="4"
      interval="3000"
      height="100%"
    >
      <v-carousel-item
        v-for="sponsor in sponsors"
        :key="sponsor.index"
        style="height: 50px !important; overflow: hidden"
      >
        <v-row>
          <div>
            <img :src="sponsor.logo" />
          </div>
        </v-row>
      </v-carousel-item>
    </v-carousel>-->
    <hooper
      id="sponsorSlider"
      ref="hooperSlide"
      :settings="hooperSettings"
      style="height: 100%"
      class="sponsor-slider"
    >
      <slide v-for="sponsor in sponsors" :key="sponsor.index">
        <img :src="sponsor.logo" v-show="pageLoaded" />
      </slide>
    </hooper>

    <!----stageview editor start--->
    <div
      v-if="isAdminComponent"
      :class="
        editorOpened
          ? 'stageview-editor-wrapper'
          : 'stageview-editor-wrapper d-none'
      "
    >
      <!--accordian start-->
      <div class="container-fluid">
        <h2>
          <i
            class="fa fa-angle-left pr-2"
            aria-hidden="true"
            @click="editorOpened = false"
          ></i>
          Editor
        </h2>
        <div class="accordion" id="stage_view">
          <!--card start-->
          <div class="card">
            <div class="card-header" id="faqhead2">
              <a
                id="hash-tag"
                href="#"
                class="btn btn-header-link collapsed"
                data-toggle="collapse"
                data-target="#stage_view2"
                aria-expanded="true"
                aria-controls="stage_view2"
                >Stage Headline</a
              >
            </div>
            <div
              id="stage_view2"
              class="collapse"
              aria-labelledby="faqhead2"
              data-parent="#stage_view"
            >
              <div class="card-body">
                <div class="form-group">
                  <label for="stageHashTag">Stage Headline</label>
                  <input
                    type="text"
                    id="stageHashTag"
                    maxlength="24"
                    class="form-control"
                    placeholder="Stage Headline"
                    v-model="hashTag"
                  />
                </div>
                <div class="text-right py-3">
                  <v-btn
                    class="px-6 mr-2 cancel-standard"
                    outlined
                    color="#1c1d26"
                    width="100px"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    class="px-6 save-standard"
                    dark
                    color="#2376e5"
                    @click="SaveStageViewSettings(2)"
                    :loading="hashTagSaving"
                    width="100px"
                  >
                    Save
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
          <!--card end-->
          <!--card start-->
          <div class="card">
            <div class="card-header" id="stage_viewhead1">
              <a
                id="left-banner"
                href="#"
                class="btn btn-header-link"
                data-toggle="collapse"
                data-target="#faq1"
                aria-expanded="true"
                aria-controls="faq1"
                >Left Banner</a
              >
            </div>
            <div
              id="faq1"
              class="collapse show"
              aria-labelledby="faqhead1"
              data-parent="#stage_view"
            >
              <!--card body start-->
              <div class="card-body">
                <div class="form-group">
                  <!-- <label for="exampleInputPassword1">Left Banner</label> -->
                  <p class="editor-d-text">
                    Supported image formats: .gif, .jpeg, .png
                  </p>
                  <p class="editor-d-text">
                    (Dimension 210 X 540 px or 7:15 ratio, max-size: 5 MB)
                  </p>
                  <div class="d-flex align-items-center">
                    <!-- <input
                      type="Text"
                      placeholder="Left Banner"
                      class="form-control"
                    /> -->
                    <img
                      class="left-banner"
                      height="120"
                      :src="leftBannerURL"
                    />
                    <div class="custom--inputfile-btn-hld ml-2">
                      <input
                        id="fuLeftBanner"
                        type="file"
                        class="custom--inputfile"
                        @change="onLeftBannerFileChange"
                      />
                      <v-btn
                        class="px-6 save-standard"
                        dark
                        color="#2376e5"
                        :loading="leftBannerUploading"
                      >
                        <v-icon color="#fff" size="20px" class="mr-1"
                          >mdi-tray-arrow-up</v-icon
                        >Upload Banner
                      </v-btn>
                    </div>
                  </div>
                </div>
                <!-- <div class="text-right py-3">
                  <v-btn class="px-6 mr-2" depressed> Cancel </v-btn>
                  <v-btn
                    class="px-6"
                    depressed
                    color="primary"
                    @click="SaveStageViewSettings()"
                  >
                    Save
                  </v-btn>
                </div> -->
              </div>
              <!--card body end-->
            </div>
          </div>
          <!--card end-->
          <!--card start-->
          <div class="card">
            <div class="card-header" id="stage_viewhead3">
              <a
                id="sponsor-logo"
                href="#"
                class="btn btn-header-link collapsed"
                data-toggle="collapse"
                data-target="#stage_view3"
                aria-expanded="true"
                aria-controls="stage_view3"
                >Sponsor Logo</a
              >
            </div>
            <div
              id="stage_view3"
              class="collapse"
              aria-labelledby="stage_viewhead3"
              data-parent="#stage_view"
            >
              <div class="card-body">
                <div class="form-group">
                  <label for="stageSponsorsTitle">Sponsors Title</label>
                  <input
                    type="text"
                    class="form-control"
                    id="stageSponsorsTitle"
                    maxlength="20"
                    placeholder="Sponsors Title"
                    v-model="sponsorsTitle"
                  />
                </div>
                <div class="form-group">
                  <label for="exampleInputPassword1">Sponsor Logo</label>
                  <p class="editor-d-text">
                    Supported image formats: .gif, .jpeg, .png<br />(Dimension
                    1200 X 628 px or 2:1 ratio, max-size: 5 MB)
                  </p>
                  <div class="d-flex align-items-center">
                    <!-- <input
                      type="Text"
                      placeholder="Left Banner"
                      class="form-control"
                    /> -->
                    <div class="custom--inputfile-btn-hld ml-2">
                      <!-- <input type="file" class="custom--inputfile" /> -->
                      <input
                        id="fuLeftBanner"
                        type="file"
                        class="custom--inputfile"
                        @change="onSponsorLogoFileChange"
                      />
                      <!-- <button type="button" class="btn btn-default">
                        Choose File
                      </button> -->
                      <v-btn
                        class="px-6 save-standard"
                        dark
                        outlined
                        color="#2376e5"
                        :loading="sponsorLogoUploading"
                      >
                        <v-icon color="#2376e5" size="20px" class="mr-1"
                          >mdi-tray-arrow-up</v-icon
                        >
                        Upload Logo
                      </v-btn>
                    </div>
                  </div>
                </div>
                <draggable class="upload-img-list">
                  <div
                    v-for="(sponsor, index) in uploadedSponsors"
                    :key="sponsor"
                    class="img-name-list mb-2"
                  >
                    <img :src="sponsor.logo" width="120" class="logo" />
                    <!-- <span
                      class="delete-ico mr-2"
                      @click="DeleteSponsorLogo(index)"
                    >
                      &nbsp;
                    </span> -->
                    <v-btn
                      text
                      icon
                      color="#000"
                      @click="DeleteSponsorLogo(index)"
                      :loading="sponsor.deleting"
                    >
                      <span class="delete-ico"> &nbsp; </span>
                    </v-btn>
                  </div>
                  <!-- <div class="img-name-list mb-2">
                    Images.png <span class="delete-ico mr-2"> &nbsp; </span>
                  </div>
                  <div class="img-name-list mb-2">
                    Images.png <span class="delete-ico mr-2"> &nbsp; </span>
                  </div> -->
                </draggable>
                <div class="text-right py-3">
                  <v-btn
                    class="px-6 mr-2 cancel-standard"
                    outlined
                    color="#1c1d26"
                    width="100px"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    class="px-6 save-standard"
                    dark
                    color="#2376e5"
                    @click="SaveStageViewSettings(3, true)"
                    :loading="sponsorsSaving"
                    width="100px"
                  >
                    Save
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
          <!--card end-->
        </div>
        <!--accordian end-->
        <!-- <div class="text-right py-3">
          <v-btn class="px-6 mr-2" depressed> Cancel </v-btn>
          <v-btn
            class="px-6"
            depressed
            color="primary"
            @click="SaveStageViewSettings(1)"
          >
            Save
          </v-btn>
        </div> -->
      </div>
    </div>
    <!----stageview editor end--->

    <!-- <v-dialog v-model="AdSettings" width="1024" >
      <v-card> 
        <div class="adclose p-3 d-flex justify-content-between align-items-center">
          <h3>Advanced Settings</h3>
          <v-btn
              color="#fff"
              small
              fab
              @click="AdSettings = false"
            >
              <v-icon size="22px" color="#333">mdi-close</v-icon>
            </v-btn>
        </div>
        <div class="p-1 d-flex justify-content-center align-items-start">
          <v-col md="6" sm="6">
            <div class="ad-setting-single-wrap">
              <label>Video Stream Quality(Default)</label>
              <v-select :items="SessionQuality" label="Choose a Video Quality" outlined></v-select>

              <div class="logo-uploader d-flex w-100 justify-content-between align-items-center mt-5">
                <p>Live Stage Logo (2:1 ratio)</p>
                <div class="file-upload final-button d-flex justify-content-end align-items-center">
                  <div class="uploaded-logo-wrap mr-3">
                    <img src="../assets/Images/reg-ico/img-icon.svg"/>
                  </div>
                  <v-btn size="120px" dark color="#1a73e8"><v-icon color="#ffffff" size="20px" class="mr-1">mdi-tray-arrow-up</v-icon> Upload</v-btn>
                </div>
              </div>

              <div class="timer-background d-flex justify-content-between align-items-center mt-5">
                <p>Live Stage Logo Hyperlink</p>
                <input type="text" name="" id="" value="https://e2m.live/"/>
              </div>

              <div class="timer-background d-flex justify-content-between align-items-center mt-5">
                <p>Live Stage Timer Background(2732px x 2048px)</p>
                <div class="d-flex justify-content-end align-items-center">
                  <div class="mr-1"><v-icon size="22px" color="#333">mdi-information-outline</v-icon></div>
                  <v-btn size="120px" dark color="#1a73e8"><v-icon color="#ffffff" size="20px" class="mr-1">mdi-tray-arrow-up</v-icon> Upload</v-btn>
                </div>
              </div>

              <div class="timer-background d-flex justify-content-between align-items-center mt-5">
                <p>Live Stage Timer Background (2048px x 2732px)</p>
                <div class="d-flex justify-content-end align-items-center">
                  <div class="mr-1"><v-icon size="22px" color="#333">mdi-information-outline</v-icon></div>
                  <v-btn size="120px" dark color="#1a73e8"><v-icon color="#ffffff" size="20px" class="mr-1">mdi-tray-arrow-up</v-icon> Upload</v-btn>
                </div>
              </div>

              <div class="timer-background d-flex justify-content-between align-items-center mt-5">
                <p>Start Live Stage In Maximized Mode</p>
                <div class="d-flex justify-content-end align-items-center">
                  <div class="mr-1"><v-icon size="22px" color="#333">mdi-information-outline</v-icon></div>
                  <v-switch color="#1a73e8" v-model="switch20"></v-switch>
                </div>
              </div>

              <div class="timer-background d-flex justify-content-between align-items-center mt-5">
                <p>Display Maximize Button</p>
                <div class="d-flex justify-content-end align-items-center">
                  <div class="mr-1"><v-icon size="22px" color="#333">mdi-information-outline</v-icon></div>
                  <v-switch color="#1a73e8" v-model="switch21"></v-switch>
                </div>
              </div>

              <div class="timer-background d-flex justify-content-between align-items-center mt-5">
                <p>Show Session Panel</p>
                <div class="d-flex justify-content-end align-items-center">
                  <div class="mr-1"><v-icon size="22px" color="#333">mdi-information-outline</v-icon></div>
                  <v-switch color="#1a73e8" v-model="switch22"></v-switch>
                </div>
              </div>

              <div class="timer-background d-flex justify-content-between align-items-center mt-5">
                <p>Show Session Right Panel</p>
                <div class="d-flex justify-content-end align-items-center">
                  <v-switch color="#1a73e8" v-model="switch23"></v-switch>
                </div>
              </div>

              <div class="timer-background d-flex justify-content-between align-items-center mt-5">
                <p>Live Stage Logo Hyperlink</p>
                <input type="text" name="" id="" value=""/>
              </div>
            </div>
          </v-col>
          <v-col md="6" sm="6">
            <div class="timer-background d-flex justify-content-between align-items-center">
              <p>Display Session Timer</p>
              <div class="d-flex justify-content-end align-items-center">
                <div class="mr-1"><v-icon size="22px" color="#333">mdi-information-outline</v-icon></div>
                <v-switch color="#1a73e8" v-model="switch24"></v-switch>
              </div>
            </div>

            <div class="timer-background d-flex justify-content-between align-items-center mt-5">
              <p>Display Audience Counter</p>
              <div class="d-flex justify-content-end align-items-center">
                <div class="mr-1"><v-icon size="22px" color="#333">mdi-information-outline</v-icon></div>
                <v-switch color="#1a73e8" v-model="switch25"></v-switch>
              </div>
            </div>

            <div class="timer-background d-flex justify-content-between align-items-center mt-5">
              <p>Display Company &amp; Title In Video Tile</p>
              <div class="d-flex justify-content-end align-items-center">
                <div class="mr-1"><v-icon size="22px" color="#333">mdi-information-outline</v-icon></div>
                <v-switch color="#1a73e8" v-model="switch26"></v-switch>
              </div>
            </div>

            <div class="timer-background d-flex justify-content-between align-items-center mt-5">
              <p>Auto Start Recording</p>
              <div class="d-flex justify-content-end align-items-center">
                <v-switch color="#1a73e8" v-model="switch27"></v-switch>
              </div>
            </div>


            <div class="timer-background d-flex justify-content-between align-items-center mt-5">
              <p>Display Agenda Type</p>
              <div >
                <v-radio-group v-model="radioGroup">
                  <div class="radio-dot d-flex justify-content-end align-items-center">
                    <v-radio color="#1a73e8" label="Full Agenda" class="mr-4"></v-radio>
                    <v-radio color="#1a73e8" label="My Agenda" class="mr-4"></v-radio>
                    <v-radio color="#1a73e8" label="Both"></v-radio>
                  </div>
                </v-radio-group>
              </div>
            </div>

            <div class="timer-background d-flex justify-content-between align-items-center mt-5">
              <p>Display Agenda Type</p>
              <div >
                <v-radio-group v-model="radioGroup2">
                  <div class="radio-dot d-flex justify-content-end align-items-center">
                    <v-radio color="#1a73e8" label="Default" class="mr-4"></v-radio>
                    <v-radio color="#1a73e8" label="Calender View" class="mr-4"></v-radio>
                  </div>
                </v-radio-group>
              </div>
            </div>

            <div class="timer-background d-flex justify-content-between align-items-center mt-5">
              <p>Allow Add-Remove MyAgenda</p>
              <div class="d-flex justify-content-end align-items-center">
                <div class="mr-1"><v-icon size="22px" color="#333">mdi-information-outline</v-icon></div>
                <v-switch color="#1a73e8" v-model="switch28"></v-switch>
              </div>
            </div>
            <div class="timer-background d-flex justify-content-between align-items-start flex-column mt-5">
              <label>Live Stage Closing Message</label>
              <textarea cols="12" rows="12" name="" id=""></textarea>
            </div>
          </v-col>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="final-button">
            <v-btn color="#1a73e8" dark @click="AdSettings = false" width="100px">
              Save
            </v-btn>
          </div>
        </v-card-actions>

        

        
      </v-card>
    </v-dialog> -->
  </div>
</template>
<style lang="scss">
.custom-v-tour .v-step__header {
  background: #19191d !important;
  color: #fff !important;
  position: relative !important;
}
.custom-v-tour .v-step {
  background: #19191d !important;
  color: #dfdfdf !important;
  font-size: 16px !important;
  border: 1px solid #b5b5b5;
  padding: 25px 30px;
}

.custom-v-tour .v-step__header:after {
  content: "";
  position: absolute;
  width: 95%;
  height: 1px;
  background: #2a2a2f;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
}

.custom-v-tour .v-step__button.v-step__button-skip,
.custom-v-tour .v-step__button.v-step__button-previous {
  border: none !important;
  background: #393a3e !important;
  color: #fff !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  border-radius: 2px !important;
  height: 35px !important;
  width: 70px !important;
}

.custom-v-tour .v-step .v-step__arrow {
  border-color: #b5b5b5 !important;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
}
.custom-v-tour .v-step__button.v-step__button-next,
.custom-v-tour .v-step__button.v-step__button-stop {
  border: none !important;
  background: #2376e5 !important;
  color: #fff !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  border-radius: 2px !important;
  height: 35px !important;
  width: 70px !important;
}

.agora-player .container {
  height: 100% !important;
}
div#divSessionEndedContainer {
  height: 100% !important;
}
#divSessionEndedContainer .container .row {
  height: 100% !important;
}
.stage-view {
  #LiveStage .live-stage-end-message {
    // margin-left: 80px;
    position: absolute;
    transform: translate(-50%);
    left: 50%;
    width: 100%;
    height: 100% !important;
  }
}
.stage-view {
  #sectionId {
    height: 100% !important	;
    background: #280304 !important;
    //padding-right: 64px !important;
    width: calc(100% - 64px) !important;
  }
  #live_stage {
    height: 100% !important	;
  }
  #LiveStage {
    height: 100% !important	;
  }
  .container.live-stage-body {
    height: 100% !important	;
  }
  .player-main-wrap {
    height: 100% !important	;
  }
  #rightPanel,
  #rightPanel.position-absolute {
    position: absolute;
    left: auto;
    // right: -64px !important;
    right: 0 !important;
    top: 0;
    z-index: 4;
  }
  #sectionId img {
    max-height: 100% !important;
  }
  // #LiveStage .live-stage-end-message {
  //   margin-left: 80px;
  // }
  // .vjs-viewer {
  //   display: none;
  // }
  .clock-circle-wrapper {
    justify-content: flex-start;
  }
  .base-timer__inner {
    font-size: 36px;
    height: 180px;
    width: 180px;
  }
  .base-timer {
    height: 180px;
    width: 180px;
  }
  .timer-clock {
    min-height: 180px;
    margin: 0 0 15px !important;
  }
  .vjs-volume-panel {
    display: flex !important;
  }
  #btnEngage {
    text-align: right !important;
  }
  #btnEngage #unreadCount:empty {
    display: none;
  }
  #btnEngage #unreadCount {
    height: 16px;
    width: 16px;
    //position: absolute;
    //background: #f9b800;
    font-size: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    //padding-left: 2px;
    border-radius: 50%;
    line-height: 1px;
    //top: 3px;
    //right: -15px;
    background-image: linear-gradient(
      to bottom,
      rgba(255, 105, 0, 1) 27%,
      rgba(246, 34, 145, 1) 73%
    ) !important;
    color: #fff;
  }
  #btnMaximize {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 99 !important;
  }
  .video-js .vjs-custom-control-spacer {
    padding-right: 36px;
  }
  #divSessionsContainer {
    padding: 0 36px !important;
  }
  .multi-session-list-wrap {
    height: calc(100% - 58px);
  }
  .hooper-track {
    margin: 0 !important;
    padding: 0 !important;
  }
  .sponsor-slider img {
    width: 100% !important;
  }
  .loading .blink_ffect_wrapper {
    display: none !important;
  }
}
</style>
<style>
.stage-view .edit-table-btn {
  min-width: 215px !important;
}
.stage-view .rt-comp.rt {
  height: 242px !important;
}

.stage-view #LiveStage .page-head {
  margin-bottom: 15px !important;
  padding-top: 15px !important;
}

@media only screen and (min-width: 1400px) and (max-width: 1441px) {
  #vueplayer.stage-view #sectionId {
    width: calc(100% - 0px) !important;
    padding-top: 6px !important;
  }
  #vueplayer.stage-view #rightPanel,
  #vueplayer.stage-view #rightPanel.position-absolute {
    right: 0 !important;
  }
  #vueplayer.stage-view {
    height: 100%;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  #vueplayer.stage-view #sectionId {
    width: calc(100% - 0px) !important;
    padding-top: 6px !important;
  }
  #vueplayer.stage-view #rightPanel,
  #vueplayer.stage-view #rightPanel.position-absolute {
    right: 0 !important;
  }
  #vueplayer.stage-view {
    height: 100%;
  }
}
.player .stage-view .top-button-wrap {
  z-index: 1;
  left: 10px;
  top: 10px;
}
.player .stage-view .stage-button {
  font-size: 14px;
  font-weight: bold;
}
/*.player-full-screen .stage-view #sectionId {
  height: 100% !important;
  overflow-y: hidden;
}*/
/*#app .stage-view #sectionId {
  height: 100% !important;
  overflow-y: hidden;
}*/
/*.player-full-screen .new-chatpanel-wrap {
  bottom: 60px !important;
  right: 60px !important;
}
.player .new-chatpanel-wrap {
  z-index: 9998;
}*/
.player .stage-full-screen {
  position: absolute !important;
  left: 0 !important;
  top: 0 !important;
  height: 100% !important;
  width: 100% !important;
}
.player .page-wrap-inner {
  overflow-y: hidden !important;
  background: #280304 !important;
}
/*#app.oncall .new-chatpanel-wrap {
  display: none !important;
}*/

.player-full-screen .stage-view .video-js .vjs-custom-control-spacer {
  padding-right: 0px !important;
}
/*.player .v-application--wrap {
  overflow: hidden !important;
}*/
/*.player .video-js .vjs-control-bar .vjs-volume-bar {
  display: none;
}*/
.stage-view.user-view .blink_ffect_wrapper {
  display: none !important;
}
</style>
<script>
import Vue from "vue";
// import router from "../router";
import db from "../components/firebaseInit";
import storageRef from "firebase";
//const storageRef = firebase;
//import APIs from "../components/APIInit";
import LiveStage from "@/views/LiveStageNG.vue";
//import axios from "axios";
import common from "@/common";
import jQuery from "jquery";
let $ = jQuery;
//import { bus } from "@/main";
import { Hooper, Slide } from "hooper";
import draggable from "vuedraggable";
import VueTour from "vue-tour";
import store from "../store";
require("vue-tour/dist/vue-tour.css");

Vue.use(VueTour);

let vm;
export default {
  components: {
    LiveStage,
    Hooper,
    Slide,
    draggable,
  },
  data() {
    return {
      stagePlayerKey: 0,
      clientId: this.$store.getters.getClient[0].id,
      eventId: this.$store.getters.getEvent,
      uid: "",
      email: "",
      name: "",
      firstName: "",
      lastName: "",
      company: "",
      phone: "",
      title: "",
      profilepic: "",
      eventName: "",
      event_collectionName: "",
      eventBGImage: "",
      pageLoaded: false,
      callStarted: false,
      isMaximized: false,
      AdSettings: false,
      //pageHtml:
      //  "<table style='height: 100%; width: 100%;'><tr style='height: 100px'><td style='width: 10%'>1</td><td style='width: 80%'>2</td><td id='rp_holder' style='width: 10%'>3</td></tr><tr style='height: calc(100% - 200px)'><td>4</td><td id='stage_holder'></td><td>6</td></tr><tr style='height: 100px'><td>7</td><td>8</td><td>9</td></tr></table>",
      pageHtml:
        "<div class='row m-0' style='height: 75px'><div class='col-3 p-0'></div><div class='col-6 p-0'></div><div class='col-3 p-0'></div></div><div class='row m-0' style='height: 400px !important;'><div class='col-3 p-0'></div><div class='col-6 p-0' id='stage_holder' style='height: 400px !important;'></div><div class='col-3 p-0'></div></div><div class='row m-0' style='height: 75px'><div class='col-3 p-0'></div><div class='col-6 p-0'></div><div class='col-3 p-0'></div></div>",
      isMobileView: false,
      isIPadView: false,
      unreadChatCount: 0,
      unreadQnACount: 0,
      hooperSettings: {
        vertical: true,
        autoPlay: true,
        infiniteScroll: true,
        centerMode: true,
        itemsToShow: 3,
        itemsToSlide: 1,
        initialSlide: 0,
        mouseDrag: true,
        wheelControl: false,
        keysControl: false,
        shortDrag: false,
        trimWhiteSpace: true,
        playSpeed: 3000,
        transition: 300,
      },

      sponsors: [],
      defaultSponsors: [
        {
          default: true,
          index: 0,
          logo: "https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FStage%2Freg.png?alt=media",
        },
        {
          default: true,
          index: 1,
          logo: "https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FStage%2Fvirtual-event.png?alt=media",
        },
        {
          default: true,
          index: 2,
          logo: "https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FStage%2Fenterprise-event.png?alt=media",
        },
        {
          default: true,
          index: 3,
          logo: "https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FStage%2Femail-followup.png?alt=media",
        },
        {
          default: true,
          index: 4,
          logo: "https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FStage%2Fchatbot.png?alt=media",
        },
      ],
      currentIndex: 0,
      pageHeight: "",
      isAdminComponent: false,
      editorOpened: false,
      leftBannerURL:
        "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2Fleft-banner.jpg?alt=media",
      leftBannerUploading: false,
      hashTag: "#e2mlive",
      hashTagSaving: false,
      sponsorsTitle: "Sponsors",
      sponsorLogoUploading: false,
      sponsorsSaving: false,
      steps: [
        {
          target: "#playerWrap",
          header: {
            title: "Welcome to Virtual Venue Editor",
          },
          content:
            "Great job!<br/> You have just built a Webinar Event. Follow the on-screen instructions and / or follow the step by step checklist to make edits. Once done, you can Publish the event & Invite guests to register.",
          params: {
            placement: "bottom",
            positionFixed: true,
            enableScrolling: false,
          },
        },
        {
          target: "#hash-tag",
          // header: {
          //   title: "Advanced Settings 1:",
          // },
          content: "Customize Headline and Logo(s)",
          params: {
            placement: "bottom",
            positionFixed: true,
            enableScrolling: false,
          },
        },
        {
          target: "#v-step-3",
          header: {
            title: "Advanced Settings:",
          },
          content: "Advanced settings for nerds! :)",
          params: {
            placement: "bottom",
            positionFixed: true,
            enableScrolling: false,
          },
        },
      ],

      tourCallbacks: {
        onNextStep: this.onTourNext,
      },
      SessionQuality: ["High", "Medium", "Low"],
      switch20: false,
      switch21: true,
      switch22: true,
      switch23: false,
      switch24: true,
      switch25: true,
      switch26: true,
      switch27: false,
      switch28: true,
      radioGroup: 1,
      radioGroup2: 1,
    };
  },
  computed: {
    liveStage() {
      return vm.$refs.liveStage;
    },
    uploadedSponsors() {
      debugger;
      var result = [];
      result = vm.sponsors.filter(function (item) {
        return !item.default;
      });
      return result;
    },
  },
  watch: {
    $route(to) {
      vm.CheckIfAdminRoute(to.name);
    },
    leftBannerURL(val) {
      $("#leftBannerURL").attr("src", val);
    },
    hashTag(val) {
      $("#hashTag").text(val);
    },
    sponsorsTitle(val) {
      $("#sponsorsTitle").text(val);
    },
    isAdminComponent() {
      vm.SetupEditorDrawer();
    },
    unreadChatCount(val) {
      var total = vm.unreadQnACount + val;
      var result = total ? total : "";
      $("#unreadCount").text(result);
    },
    unreadQnACount(val) {
      var total = vm.unreadChatCount + val;
      var result = total ? total : "";
      $("#unreadCount").text(result);
    },
    callStarted(val) {
      if (val) {
        $("#app").addClass("oncall");
        if ($("#btnEngage")) {
          //$("#btnEngage").show();
        }
        if ($("#btnMaximize")) {
          //$("#btnMaximize").show();
          //$("#btnMaximize").detach().appendTo("#stage_holder");
        }
        vm.liveStage.openRightPanel("message");
      } else {
        $("#app").removeClass("oncall");
        if ($("#btnEngage")) {
          //$("#btnEngage").hide();
        }
        if ($("#btnMaximize")) {
          //$("#btnMaximize").hide();
          //$("#btnMaximize").detach().appendTo("#live_stage");
        }
      }
    },
    isMaximized(val) {
      if (val) {
        if ($("#leftMenuParent")) {
          $("#leftMenuParent").addClass("d-none");
        }
        if ($("#leftmenu")) {
          $("#leftmenu").hide();
        }
        if ($("#stage_holder")) {
          $("#stage_holder").addClass("stage-full-screen");
        }
        if ($("#rightPanel")) {
          $("#rightPanel").detach().appendTo("#playerWrap");
          $("#rightPanel").removeClass("position-absolute");
          //$("#rightPanel").removeClass("d-none");
        }
      } else {
        if ($("#leftMenuParent")) {
          $("#leftMenuParent").removeClass("d-none");
        }
        if ($("#leftmenu")) {
          $("#leftmenu").show();
        }
        if ($("#stage_holder")) {
          $("#stage_holder").removeClass("stage-full-screen");
        }
        if ($("#rightPanel")) {
          $("#rightPanel").detach().appendTo("#sectionId");
          $("#rightPanel").addClass("position-absolute");
          //$("#rightPanel").addClass("d-none");
        }
      }
    },
    isMobileView(val) {
      if (val) {
        //router.push("/screeninfo");
      }
    },
    isIPadView(val) {
      if (val) {
        //router.push("/screeninfo");
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (vm.callStarted) {
      let fullPath = location.origin + to.fullPath;
      window.open(fullPath, "_blank");
    } else {
      $("#app").removeClass("player");
      $("body").removeClass("player");
      next(true);
    }
  },
  beforeCreate() {
    //alert("beforeCreate");
  },
  created() {
    //alert("");
    vm = this;
    //vm.pageHeight = vm.getHeight();
    vm.uid = vm.getSessionUserId();
    vm.event_collectionName = vm.getEventCollectionName();
    vm.isMobileView = vm.isMobile();
    vm.isIPadView = vm.isIPad();
    $(window).resize(function () {
      //alert("aaaa");
      vm.isMobileView = vm.isMobile();
      vm.isIPadView = vm.isIPad();
    });
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    if (obj && obj.EventBranding && obj.EventBranding.length > 0) {
      vm.eventBGImage = obj.EventBranding[0].eventBGImage;
    }
    vm.getStageData();
    setTimeout(() => {
      //vm.stagePlayerKey += 1;
      //$("#live_stage").detach().appendTo("#stage_holder");
    }, 10000);
  },
  updated() {},
  beforeDestroy() {},
  mounted() {
    vm.CheckIfAdminRoute(vm.$route.name);
    //alert(vm.$route.name)
    //setTimeout(() => {
    //  var height = vm.getHeight();
    //  //alert(height);
    //  $("#vueplayer").css("height", height.replace("height:", ""));
    //}, 5000);
    //$("#tabWrap [role='tablist']").prepend(pin);

    if (vm.isAdminComponent) {
      setTimeout(() => {
        if (
          !vm.$store.getters.getAdminTour ||
          !vm.$store.getters.getAdminTour.includes("Stage")
        ) {
          if (vm.$store.getters.adminTourSeen) {
            store.commit(
              "setAdminTour",
              vm.$store.getters.adminTourSeen + ",Stage"
            );
          } else {
            store.commit("setAdminTour", "Stage");
          }

          vm.$tours["adminStageViewTour"].start();
        }
      }, 5000);
    }
  },
  methods: {
    AdSettingsPop() {
      vm.AdSettings = true;
    },
    onTourNext(currentStep) {
      $("[data-openeditor='hash-tag']").click();
      if (currentStep == 1) {
        vm.editorOpened = false;
      }
    },
    SetupEditorDrawer() {
      if (this.isAdminComponent == true) {
        if ($("[data-openeditor]").length > 0) {
          $("[data-openeditor]").click(function (e) {
            var editorId = $(this).attr("data-openeditor");
            if (editorId) {
              vm.editorOpened = true;
              if ($("#" + editorId).hasClass("collapsed")) {
                $("#" + editorId).click();
              }
            }
            e.stopPropagation();
          });
        }
      }
    },
    CheckIfAdminRoute(routeName) {
      if (routeName == "StageView") {
        this.isAdminComponent = false;
      } else {
        this.isAdminComponent = true;
      }
    },
    afterSlideTab(arg) {
      vm.currentIndex = arg.currentSlide;
      //if (arg && arg.currentSlide) {
      //  var index = arg.currentSlide;
      //  vm.onTabChange(
      //    vm.dateTabs[index].DateTabId,
      //    vm.dateTabs[index].StartTime,
      //    vm.dateTabs[index].EndTime
      //  );
      //}
    },
    getStageData() {
      if (vm.event_collectionName) {
        db.collection(vm.event_collectionName)
          .doc("EventInfo")
          .get()
          .then((doc) => {
            if (doc.exists) {
              var data = doc.data();
              vm.pageHtml = data.StageHtml;

              var leftBannerURL = (
                data.StageLeftBannerURL ? data.StageLeftBannerURL : ""
              ).trim();
              if (leftBannerURL) {
                vm.leftBannerURL = leftBannerURL;
              }
              var hashTag = (data.StageHashTag ? data.StageHashTag : "").trim();
              if (hashTag) {
                vm.hashTag = hashTag;
              }
              var sponsorsTitle = (
                data.StageSponsorsTitle ? data.StageSponsorsTitle : ""
              ).trim();
              if (sponsorsTitle) {
                vm.sponsorsTitle = sponsorsTitle;
              }
              if (
                data.StageSponsors &&
                Array.isArray(data.StageSponsors) &&
                data.StageSponsors.length > 0
              ) {
                vm.sponsors = data.StageSponsors;
              } else {
                vm.sponsors = vm.defaultSponsors.filter(function () {
                  return true;
                });
              }

              setTimeout(() => {
                debugger;
                if ($("#live_stage")) {
                  $("#live_stage").detach().appendTo("#stage_holder");
                }
                if ($("#sponsorSlider")) {
                  $("#sponsorSlider").detach().appendTo("#sponsor_slider");
                }
                if ($("#sectionId")) {
                  $("#sectionId").addClass("position-relative");
                }
                if ($("#rightPanel")) {
                  $("#rightPanel").detach().appendTo("#sectionId");
                  $("#rightPanel").addClass("position-absolute");
                  //$("#rightPanel").addClass("d-none");
                }
                if ($("#btnAllSessions")) {
                  $("#btnAllSessions").show();
                }
                if ($("#btnEngage")) {
                  //$("#btnEngage").hide();
                }
                if ($("#btnMaximize")) {
                  //$("#btnMaximize").hide();
                }
                if ($("#leftMenuParent")) {
                  $("#leftMenuParent").removeClass("d-none");
                }
                if ($("#leftmenu")) {
                  $("#leftmenu").show();
                }

                let btnEngage = document.querySelector("#btnEngage");
                if (btnEngage) {
                  btnEngage.addEventListener("click", (e) => {
                    vm.engageToggle();
                    e.stopPropagation();
                  });
                } else {
                  //alert("not found");
                }
                let btnMaximize = document.querySelector("#btnMaximize");
                if (btnMaximize) {
                  btnMaximize.addEventListener("click", (e) => {
                    vm.maximizeToggle();
                    e.stopPropagation();
                  });
                } else {
                  //alert("not found");
                }
                vm.pageLoaded = true;
                $("#btnMaximize").detach().appendTo("#stage_holder");
                if (!vm.isAdminComponent) {
                  vm.liveStage.openRightPanel("message");
                }
                vm.SetupEditorDrawer();

                $("#leftBannerURL").attr("src", vm.leftBannerURL);
                $("#hashTag").text(vm.hashTag);
                $("#sponsorsTitle").text(vm.sponsorsTitle);
              }, 1000);
            }
          });
      }
    },
    engageToggle() {
      //$("#rightPanel").toggleClass("d-none");
      vm.liveStage.openRightPanel("message");
    },
    maximizeToggle() {
      vm.liveStage.resizePlayer(true);
    },
    onCallStarted(callStarted) {
      vm.callStarted = callStarted;
    },
    onResizeStage(isManual, isMaximized) {
      //alert(isManual);
      //alert(isMaximized);
      //if (vm.pageLoaded) {
      vm.isMaximized = isMaximized;
      //}
      //if (vm.pageLoaded) {
      //  vm.isMaximized = !vm.isMaximized;
      //  vm.liveStage.resizePlayer(isManual);
      //}
    },
    unreadChatCountChanged(val) {
      //alert("unreadChatCountChanged: " + val);
      vm.unreadChatCount = val;
    },
    unreadQnACountChanged(val) {
      //alert("unreadQnACountChanged: " + val);
      vm.unreadQnACount = val;
    },
    stageClicked() {
      //alert("stageClicked");
      vm.liveStage.stageClicked();
      vm.editorOpened = false;
      //if (vm.isMaximized) {
      //} else {
      //  if ($("#rightPanel")) {
      //    //$("#rightPanel").addClass("d-none");
      //  }
      //}
    },
    onClickHandler(event) {
      console.log(event);
      //this.rtmpDialog.state = true;
      // event.target is the clicked element object
      //vm.AddAnalitics(event, "click");
    },
    exitmenu: function () {
      $(".tab-content-one .tab-pane").removeClass("active");
      $(".nav-link.tab-link").removeClass("active");
    },
    getHeight() {
      debugger;
      return common.getHeaderHeight();
      //return common.getHeaderHeightPercent();
    },
    onLeftBannerFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      vm.leftBannerUploading = true;
      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        var metadata = {
          contentType: file.type,
        };

        const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          // invalid file type code goes here.
          //alert("Only gif,jpeg & png file allowed.");
          vm.showSnackbar("Only gif,jpeg & png file allowed.", "error", "top");
          return false;
        }

        //$(".loader-profile").addClass("show");
        debugger;
        storageRef
          .storage()
          .ref()
          .child(
            vm.eventcollectionname +
              "/Stage/" +
              file.name +
              "_" +
              new Date().getTime()
          )
          .put(file, metadata)
          .then(function (snapshot) {
            snapshot.ref
              .getDownloadURL()
              .then(function (imgURL) {
                debugger;
                vm.leftBannerUploading = false;
                vm.leftBannerURL = imgURL;
                vm.SaveStageViewSettings(1);
              })
              .then(() => {
                vm.leftBannerUploading = false;
                //alert("Successfully updated the record");
                vm.showSnackbar("Banner uploaded successfully.", "info", "top");
              })
              .catch((error) => {
                vm.leftBannerUploading = false;
                // console.error(
                //   "There was an error editing the record: " + error
                // );
                vm.showSnackbar(
                  "There was an error editing the record: " + error,
                  "error",
                  "top"
                );
              });
          })
          .catch(function (error) {
            vm.leftBannerUploading = false;
            //$("body").addClass("loaded");
            // [START onfailure]
            //console.error("Upload failed:", error);
            vm.showSnackbar("Upload failed: " + error, "error", "top");
            // [END onfailure]
          });
        // [END oncomplete]
      }
    },
    onSponsorLogoFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      vm.sponsorLogoUploading = true;
      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        var metadata = {
          contentType: file.type,
        };

        const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          // invalid file type code goes here.
          //alert("Only gif,jpeg & png file allowed.");
          vm.showSnackbar("Only gif,jpeg & png file allowed.", "error", "top");
          return false;
        }

        //$(".loader-profile").addClass("show");
        debugger;
        storageRef
          .storage()
          .ref()
          .child(
            vm.eventcollectionname +
              "/Stage/" +
              file.name +
              "_" +
              new Date().getTime()
          )
          .put(file, metadata)
          .then(function (snapshot) {
            snapshot.ref
              .getDownloadURL()
              .then(function (imgURL) {
                vm.sponsorLogoUploading = false;
                debugger;
                vm.sponsors.push({ index: vm.sponsors.length, logo: imgURL });
                vm.SaveStageViewSettings(3);
              })
              .then(() => {
                vm.sponsorLogoUploading = false;
                //alert("Successfully updated the record");
                vm.showSnackbar("Logo uploaded successfully.", "info", "top");
              })
              .catch((error) => {
                vm.sponsorLogoUploading = false;
                // console.error(
                //   "There was an error editing the record: " + error
                // );
                vm.showSnackbar(
                  "There was an error editing the record: " + error,
                  "error",
                  "top"
                );
              });
          })
          .catch(function (error) {
            vm.sponsorLogoUploading = false;
            //$("body").addClass("loaded");
            // [START onfailure]
            //console.error("Upload failed:", error);
            vm.showSnackbar("Upload failed: " + error, "error", "top");
            // [END onfailure]
          });
        // [END oncomplete]
      }
    },
    DeleteSponsorLogo(index) {
      debugger;
      vm.sponsors[index].deleting = true;
      vm.sponsors = vm.sponsors.filter(function () {
        return true;
      });
      //vm.sponsors.splice(index, 1);
      vm.SaveStageViewSettings(3, false, true, index);
    },
    SaveStageViewSettings(requestType, saveAll, isDelete, index) {
      if (vm.event_collectionName) {
        db.collection(vm.event_collectionName)
          .doc("EventInfo")
          // .doc("Settings")
          // .collection("StageView")
          // .doc("StageViewSettings")
          .get()
          .then((doc) => {
            // let headers = {
            //   "content-type": "application/json",
            //   Authorization: "Bearer " + vm.getSessionToken(),
            // };
            // var collection = vm.event_collectionName + "Settings/StageView/";
            //   //Left Banner
            //   var requestData = {
            //     collection: collection,
            //     instance: vm.event_collectionName,
            //     data: {
            //       LastModifiedDate: new Date(),
            //       LeftBannerURL: vm.uid,
            //       id: "StageViewSettings",
            //     },
            //   };
            // axios
            //   .put(APIs.WriteObject, requestData, {
            //     headers: headers,
            //   })
            //   .then((responseData) => {
            //     debugger;
            //     alert("Mute all");
            //     console.log(responseData);
            //   })
            //   .catch(function (error) {
            //     console.error("Error on mute all: ", error);
            //   });
            if (requestType == 1) {
              vm.leftBannerUploading = true;
            } else if (requestType == 2) {
              vm.hashTagSaving = true;
            } else if (requestType == 3) {
              if (saveAll) {
                vm.sponsorsSaving = true;
                var sponsorList = $(".upload-img-list .logo");
                if (sponsorList.length > 0) {
                  var sponsors = [];
                  for (var i = 0; i < sponsorList.length; i++) {
                    var sponsor = sponsorList[i];
                    if ($(sponsor).attr("src")) {
                      sponsors.push({ index: i, logo: $(sponsor).attr("src") });
                    }
                  }
                  if (sponsors.length > 0) {
                    vm.sponsors = sponsors;
                  }
                }
              } else if (isDelete) {
                if (index >= 0) {
                  vm.sponsors[index].deleting = true;
                  vm.sponsors = vm.sponsors.filter(function () {
                    return true;
                  });
                }
              } else {
                vm.sponsorLogoUploading = true;
              }
            }
            var docObjet = new Object();
            if (doc.exists) {
              //var data = doc.data();
              var validData = false;
              if (requestType == 1) {
                //Left Banner
                var leftBannerURL = (
                  vm.leftBannerURL ? vm.leftBannerURL : ""
                ).trim();
                if (leftBannerURL) {
                  validData = true;
                  docObjet.StageLeftBannerURL = leftBannerURL;
                }
              } else if (requestType == 2) {
                //Hash Tag
                var hashTag = (vm.hashTag ? vm.hashTag : "").trim();
                if (hashTag) {
                  validData = true;
                  docObjet.StageHashTag = hashTag;
                }
              } else if (requestType == 3) {
                //Hash Tag
                var sponsorsTitle = (
                  vm.sponsorsTitle ? vm.sponsorsTitle : ""
                ).trim();
                if (sponsorsTitle) {
                  validData = true;
                  docObjet.StageSponsorsTitle = sponsorsTitle;
                }
                var filterSponsors = vm.sponsors.filter(function (item) {
                  return !item.default && !item.deleting;
                });
                if (filterSponsors.length > 0 || (isDelete && index >= 0)) {
                  validData = true;
                  docObjet.StageSponsors = [];
                  for (var n = 0; n < filterSponsors.length; n++) {
                    docObjet.StageSponsors.push({
                      index: n,
                      logo: filterSponsors[n].logo,
                    });
                  }
                }
              }
              if (validData) {
                db.collection(vm.event_collectionName)
                  .doc("EventInfo")
                  // .doc("Settings")
                  // .collection("StageView")
                  // .doc("StageViewSettings")
                  .update(docObjet)
                  .then(function () {
                    if (requestType == 1) {
                      vm.leftBannerUploading = false;
                    } else if (requestType == 2) {
                      vm.hashTagSaving = false;
                    } else if (requestType == 3) {
                      vm.sponsorLogoUploading = false;
                      vm.sponsorsSaving = false;
                      // if (isDelete && index >= 0) {
                      //   //vm.sponsors[index].deleting = false;
                      //   vm.sponsors = vm.sponsors.filter(function (item) {
                      //     return !item.default && !item.deleting;
                      //   });
                      // }
                      filterSponsors = vm.sponsors.filter(function (item) {
                        return !item.default && !item.deleting;
                      });
                      if (filterSponsors.length > 0) {
                        vm.sponsors = filterSponsors;
                      } else {
                        vm.sponsors = vm.defaultSponsors.filter(function () {
                          return true;
                        });
                      }
                    }
                    //alert("StageViewSettings Saved");
                  })
                  .catch((error) => {
                    vm.leftBannerUploading = false;
                    vm.hashTagSaving = false;
                    vm.sponsorLogoUploading = false;
                    if (isDelete && index >= 0) {
                      vm.sponsors[index].deleting = false;
                    }
                    vm.sponsors = vm.sponsors.filter(function () {
                      return true;
                    });
                    vm.sponsorsSaving = false;
                    console.log(error);
                  });
              } else {
                vm.leftBannerUploading = false;
                vm.hashTagSaving = false;
                vm.sponsorLogoUploading = false;
                if (isDelete && index >= 0) {
                  vm.sponsors[index].deleting = false;
                }
                vm.sponsorsSaving = false;
              }
            } else {
              vm.leftBannerUploading = false;
              vm.hashTagSaving = false;
              vm.sponsorLogoUploading = false;
              if (isDelete && index >= 0) {
                vm.sponsors[index].deleting = false;
              }
              vm.sponsors = vm.sponsors.filter(function () {
                return true;
              });
              vm.sponsorsSaving = false;
              // if (requestType == 1) {
              //   //Left Banner
              //   docObjet.LeftBannerURL = "";
              // } else if (requestType == 2) {
              //   //Hash Tag
              //   docObjet.HashTag = "";
              // } else if (requestType == 3) {
              //   //Hash Tag
              //   docObjet.SponsorLogo = [];
              // }
              // if (requestType > 0) {
              //   db.collection(vm.event_collectionName)
              //     .doc("EventInfo")
              //     //.doc("Settings")
              //     //.collection("StageView")
              //     //.doc("StageViewSettings")
              //     .set(docObjet)
              //     .then(function () {
              //       alert("StageViewSettings Saved");
              //     })
              //     .catch((error) => {
              //       console.log(error);
              //     });
              // }
            }
          })
          .catch((error) => {
            vm.leftBannerUploading = false;
            vm.hashTagSaving = false;
            vm.sponsorLogoUploading = false;
            if (isDelete && index >= 0) {
              vm.sponsors[index].deleting = false;
            }
            vm.sponsors = vm.sponsors.filter(function () {
              return true;
            });
            vm.sponsorsSaving = false;
            console.log(error);
          });
      }
    },
  },
};
</script>